import {navigationRef} from '@shared/navigation/navigationRef';
import {GlobalError, GlobalErrorProp} from './GlobalErrorprops';
import {t} from 'i18next';
import {errorHandler} from '@shared/constants/errorHandlers';

export const errorStatuses = {
  500: '500',
  400: '400',
  itf_140: 'itf_140',
  itf_141: 'itf_141',
};

/**
 * Returns a formatted error object for modal display.
 * @param status - HTTP status code
 * @param errorCode - Specific API error code
 * @returns object | null
 */
export const getErrorObject = ({
  message,
  status,
  isFromRepairDetails,
}: GlobalErrorProp) => {
  switch (status) {
    case errorStatuses[500]:
      return {
        subTitle: message ? message : 'common.networkError.unableTitle',
        title:
          message?.includes(errorHandler?.notInActivity) ||
          message?.includes(errorHandler?.alreadyInShift)
            ? t('createFlow.common.modalTitles.info')
            : t('createFlow.common.modalTitles.error'),
        message: '',
        ctas: isFromRepairDetails
          ? [{label: 'common.networkError.unableCta', type: 'NAVIGATE'}]
          : [{label: 'common.networkError.unableCtaDismiss', type: 'DISMISS'}],
        screen: isFromRepairDetails ? 'repairDetails' : '',
        noTranslation: false,
      };
    case errorStatuses[400]:
      return {
        subTitle: message ? message : 'Bad Request',
        title:
          message?.includes(errorHandler?.notInActivity) ||
          message?.includes(errorHandler?.alreadyInShift)
            ? t('createFlow.common.modalTitles.info')
            : t('createFlow.common.modalTitles.error'),
        message: '',
        ctas: isFromRepairDetails
          ? [{label: 'Back to Repairs', type: 'NAVIGATE'}]
          : [{label: 'OK', type: 'DISMISS'}],
        screen: isFromRepairDetails ? 'repairDetails' : '',
        noTranslation: false,
      };
    default:
      return {
        subTitle: message,
        title: '',
        message: message ? '' : '',
        ctas: isFromRepairDetails
          ? [{label: 'common.networkError.unableCta', type: 'NAVIGATE'}]
          : [{label: 'common.networkError.unableCtaDismiss', type: 'DISMISS'}],
        screen: isFromRepairDetails ? 'repairDetails' : '',
        noTranslation: false,
      };
  }
};
